import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  btn: {
    padding: "0px",
  },
});
